import { useState } from "react";
import moment from "moment";

// hooks
import { useParams, useHistory } from "react-router";

// components
import { Button, IconButton } from "@mui/material";
import {
  Today as CalendarIcon,
  ChevronLeft as PrevIcon,
  ChevronRight as NextIcon,
} from "@mui/icons-material";

import getDate from "../../utils/getDate";
import DatePicker from "../../components/DatePicker";

const DateNavigation = () => {
  const params = useParams();
  const history = useHistory();

  let date = getDate(params);
  if (!date) {
    date = moment();
  }
  const dateLabel = date.format("ddd, DD.MMM yyyy");
  const onChange = (date) => history.push(`/${date.format("yyyy-MM-DD")}`);
  const addDate = (inc) => onChange(date.add(inc, "days"));

  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const toggleDatePicker = () => setDatePickerOpen(!datePickerOpen);

  return (
    <div>
      <IconButton color="inherit" onClick={() => addDate(-1)}>
        <PrevIcon fontSize="small" />
      </IconButton>
      <Button
        color="inherit"
        startIcon={<CalendarIcon />}
        onClick={toggleDatePicker}
      >
        {dateLabel}
      </Button>
      <IconButton color="inherit" onClick={() => addDate(1)}>
        <NextIcon fontSize="small" />
      </IconButton>
      <DatePicker
        variant="dialog"
        open={datePickerOpen}
        setOpen={setDatePickerOpen}
        date={date}
        onChange={onChange}
      />
    </div>
  );
};

export default DateNavigation;
